export default {
  "projets": {
    "heroTitle": "我们的已完成项目",
    "heroSubtitle": "发现我们在非洲的6个国家的成就：超过1000个项目",
    "stats": {
      "projects": "已完成项目",
      "countries": "国家",
      "capacity": "装机容量"
    },
    "filters": {
      "categoryLabel": "类别",
      "regionLabel": "地区",
      "resultsCount": "找到 {{count}} 个项目",
      "categories": {
        "tous": "所有项目",
        "micro-reseaux": "微电网",
        "industriel": "工业",
        "residentiel": "住宅",
        "telecoms": "电信",
        "btp": "土木工程与建筑",
        "medical": "医疗"
      },
      "regions": {
        "toutes": "所有地区",
        "afrique": "非洲",
        "asie": "亚洲",
        "ameriques": "美洲",
        "europe": "欧洲"
      }
    },
    "photoGallery": {
      "badge": "图库",
      "title": "我们的工地照片",
      "subtitle": "我们安装和现场工作的真实图像。点击放大。",
      "categories": {
        "tous": "所有工地",
        "genie-civil": "土木工程",
        "btp": "建筑与施工",
        "installation-electrique": "电气安装",
        "montage-solaire": "太阳能安装"
      },
      "emptyState": "此类别中没有照片"
    },
    "projectCard": {
      "capacity": "容量：",
      "beneficiaries": "受益者：",
      "duration": "工期：",
      "partners": "合作伙伴："
    },
    "emptyState": {
      "title": "未找到项目",
      "description": "请尝试调整筛选条件以查看更多结果。"
    },
    "cta": {
      "title": "您的项目是下一个吗？",
      "subtitle": "加入我们满意的客户，享受我们在可再生能源项目方面的专业知识。",
      "quoteBtn": "获取报价",
      "contactBtn": "联系我们"
    },
    "list": [
      {
        "titre": "津巴布韦农村微电网",
        "description": "为12个农村村庄电气化安装完整的微电网，配备智能管理系统和锂电池储能。",
        "details": { "beneficiaires": "15,000名居民", "duree": "18个月", "partenaires": "世界银行，津巴布韦政府" }
      },
      {
        "titre": "中国工业园区",
        "description": "工业区太阳能-电网混合系统，实现能源优化并降低60%电力成本。",
        "details": { "beneficiaires": "50家企业", "duree": "24个月", "partenaires": "省政府，商会" }
      },
      {
        "titre": "美国大学校园",
        "description": "大学校园太阳能储能安装，包括电动车充电站。",
        "details": { "beneficiaires": "25,000名学生", "duree": "12个月", "partenaires": "加州大学，能源部" }
      },
      {
        "titre": "柬埔寨农村医院",
        "description": "医疗中心应急太阳能系统，具备持续供电和自动备份功能。",
        "details": { "beneficiaires": "每年50,000名患者", "duree": "8个月", "partenaires": "世界卫生组织，卫生部" }
      },
      {
        "titre": "贝宁电信网络",
        "description": "为50个电信站点提供太阳能供电，配备集中监控。",
        "details": { "beneficiaires": "200万用户", "duree": "15个月", "partenaires": "电信运营商，贝宁ARCEP" }
      },
      {
        "titre": "尼日尔迷你电网",
        "description": "为8个村庄提供社区微电网，配备移动支付系统。",
        "details": { "beneficiaires": "12,000名居民", "duree": "20个月", "partenaires": "非洲开发银行，粮农组织" }
      },
      {
        "titre": "摩洛哥太阳能农场",
        "description": "连接国家电网的大型太阳能农场，采用太阳能跟踪技术。",
        "details": { "beneficiaires": "100,000户家庭", "duree": "30个月", "partenaires": "MASEN，欧洲银行" }
      },
      {
        "titre": "法国购物中心",
        "description": "屋顶太阳能安装，自用并出售余电。",
        "details": { "beneficiaires": "每天50,000名访客", "duree": "6个月", "partenaires": "奥弗涅-罗讷-阿尔卑斯大区，ADEME" }
      },
      {
        "titre": "布基纳法索金矿",
        "description": "采矿作业太阳能-柴油混合系统，减少40%燃料消耗。",
        "details": { "beneficiaires": "2,000名员工", "duree": "18个月", "partenaires": "矿业公司，国际金融公司" }
      },
      {
        "titre": "塞内加尔地区医院",
        "description": "地区医院备用太阳能系统，配备认证医疗逆变器。",
        "details": { "beneficiaires": "每年200,000名患者", "duree": "10个月", "partenaires": "卫生部，法国合作署" }
      },
      {
        "titre": "印度科技大学",
        "description": "配备能源管理系统和研究实验室的智能太阳能校园。",
        "details": { "beneficiaires": "30,000名学生", "duree": "14个月", "partenaires": "卡纳塔克邦政府，联合国教科文组织" }
      },
      {
        "titre": "科特迪瓦电信网络",
        "description": "为4G/5G基础设施提供太阳能供电，配备高容量备用电池。",
        "details": { "beneficiaires": "500万用户", "duree": "12个月", "partenaires": "Orange CI，ARTCI" }
      },
      {
        "titre": "MTN铁塔基础 — 贝宁",
        "description": "为自支撑和拉线式电信铁塔建造120个钢筋混凝土基础。在全国15个站点进行土方工程、钢筋绑扎、模板安装和混凝土浇筑。",
        "details": { "beneficiaires": "300万用户", "duree": "10个月", "partenaires": "MTN贝宁，华为" }
      },
      {
        "titre": "工业钢结构 — 尼日利亚",
        "description": "为一座12,000平方米物流仓库制造和安装850吨钢结构。桁架梁、檩条、支撑和双层覆面板。",
        "details": { "beneficiaires": "创造500个就业岗位", "duree": "14个月", "partenaires": "丹格特集团，爱立信" }
      },
      {
        "titre": "电信基础 — 布基纳法索",
        "description": "在农村地区建造200个电信铁塔基础。岩土工程研究、浅基础和深基础、接地网。",
        "details": { "beneficiaires": "150万用户", "duree": "8个月", "partenaires": "Orange布基纳法索，诺基亚" }
      },
      {
        "titre": "数据中心 — 塞内加尔",
        "description": "交钥匙建造一座3,200平方米数据中心，包括结构工程、钢结构、防水、技术标段和冗余冷却系统。",
        "details": { "beneficiaires": "区域运营商", "duree": "18个月", "partenaires": "Sonatel，华为技术" }
      }
    ]
  }
};